/* unplugin-vue-components disabled */import script from "./LayoutIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./LayoutIndex.vue?vue&type=script&setup=true&lang=js"

import "./LayoutIndex.vue?vue&type=style&index=0&id=ced83af8&lang=scss"

const __exports__ = script;

export default __exports__